import React from "react";
import styled, { css } from "styled-components";
import colours from "assets/colours";
import { oneOf } from "prop-types";

export const BannerContainer = styled.div`
  min-height: 224px;
  background: ${colours.backgroundGreen};
  border-radius: 25px;
  padding: 38px;
  position: relative;
  max-width: 1366px;
  ${({ variant }) =>
    variant &&
    css`
      background: ${colours[variant]};
    `};
`;

const Banner = ({ children, variant, ...rest }) => (
  <BannerContainer {...rest} variant={variant}>
    {children}
  </BannerContainer>
);

export default Banner;

Banner.propTypes = {
  variant: oneOf(["", ...Object.keys(colours)]),
};
